import { chakra } from '@chakra-ui/react'

export const TranscriptPanelContainer = chakra('div', {
    baseStyle: {
        width: '100%',
        height: '100%',
        position: 'relative',
        containerType: 'size',

        '& .chakra-modal__overlay': {
            position: 'absolute',
            width: '100%',
            height: '100%',
        },
        '& .chakra-modal__content-container': {
            position: 'absolute',
            width: '100%',
            height: '100%',
        },
        '& .chakra-modal__content': {
            position: 'absolute !important',
        },
    },
})
